import BaseDecorator from "./BaseDecorator";
import CompanyDecorator from "./CompanyDecorator";
import PaymentProfileDecorator from "./PaymentProfileDecorator";
import AgentCooperationDecorator from "./AgentCooperationDecorator";

export default class CompanyFullDecorator extends CompanyDecorator {
  constructor(data) {
    super({
      ...data,

      all_agent_cooperations: data.all_agent_cooperations.map((x) => new AgentCooperationDecorator(x)),

      company_payment_profile_relations: data.company_payment_profile_relations
        .map(
          (rel) =>
            new BaseDecorator({
              ...rel,
              payment_profile: new PaymentProfileDecorator(rel.payment_profile),
            })
        )
        .sort((a, b) => (b.payment_profile.name.toLowerCase() < a.payment_profile.name.toLowerCase() ? 1 : -1)),
    });
  }

  get payment_profiles() {
    return this.company_payment_profile_relations.map((rel) => rel.payment_profile);
  }

  get agent_cooperations_as_supplier() {
    return this.all_agent_cooperations.filter((coop) => coop.supplier.id == this.id);
  }

  get agent_cooperations_as_agent() {
    return this.all_agent_cooperations.filter((coop) => coop.agent.id == this.id);
  }

  get active_agents_ids() {
    return this.agent_cooperations_as_supplier.filter((coop) => coop.active).map((coop) => coop.agent.id);
  }

  get active_suppliers_ids() {
    return this.agent_cooperations_as_agent.filter((coop) => coop.active).map((coop) => coop.supplier.id);
  }

  get available_locales() {
    return this.translations.map((t) => t.locale);
  }

  get default_locale() {
    if (this.available_locales.indexOf(I18n.locale) !== -1) {
      return I18n.locale;
    } else if (this.available_locales.indexOf("en") !== -1) {
      return "en";
    } else {
      return this.translations[0] && this.translations[0].locale;
    }
  }

  get translation() {
    return (
      this.translations.find((t) => t.locale === this.default_locale) || {
        uuid: this.default_locale,
        locale: this.default_locale,
      }
    );
  }

  getPossibleSuppliers({ withMyself = true, enabled_by_supplier, enabled_by_agent } = {}) {
    return [
      ...(withMyself && this.supplier ? [this] : []),
      ...this.agent_cooperations_as_agent
        .filter((coop) => enabled_by_supplier === undefined || coop.enabled_by_supplier === enabled_by_supplier)
        .filter((coop) => enabled_by_agent === undefined || coop.enabled_by_agent === enabled_by_agent)
        .map((coop) => coop.supplier)
        .filter((company) => company.supplier),
    ].sort((a, b) => a.name.localeCompare(b.name));
  }

  getPossibleAgents({ withMyself = true, enabled_by_supplier, enabled_by_agent } = {}) {
    return [
      ...(withMyself && this.agent ? [this] : []),
      ...this.agent_cooperations_as_supplier
        .filter((coop) => enabled_by_supplier === undefined || coop.enabled_by_supplier === enabled_by_supplier)
        .filter((coop) => enabled_by_agent === undefined || coop.enabled_by_agent === enabled_by_agent)
        .map((coop) => coop.agent),
    ].sort((a, b) => a.name.localeCompare(b.name));
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/CompanyFullDecorator.js